<template>
  <div id="listNotifs">
    <v-sheet style="margin-right: 25px;">
        <v-switch
          @change="findData()"
          v-model="exibirExpirados"
          inset
          color="#2A5377"
          :label="`Exibir notificações canceladas/expiradas`"
        ></v-switch>
      </v-sheet>    
    <v-layout v-resize="onResize" style="display:flex;flex-flow: column;">
      <v-container
        v-if="loadinData"
        style="height: 400px;display: flex;margin-top:150px; justify-content: center;"
      >
        <v-row class="fill-height" align-content="center" justify="center">
          <v-col class="subtitle-1 text-center" cols="12">Baixando dados..</v-col>
          <v-col cols="6">
            <v-progress-linear color="#88C658" indeterminate rounded height="6"></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <div v-else>        
        <v-data-table
          :headers="headers"
          rows-per-page-text="Items por página"
          :items="arquivosArr"
          :hide-headers="isMobile"
          :class="{mobile: isMobile}"
          item-key="NOTCONTADOR"
          :pagination.sync="pagination"
          no-data-text="Nada foi encontrado."
          no-results-text="Nada foi encontrado."
          :search="search"
          style="width: 100%!important;"
          :sort-by="['NOTCONTADOR']"
          :sort-desc="[true]"
          multi-sort
          :rows-per-page-items="[
              {
                text: '100',
                value: 100
              },
              {
                text: '300',
                value: 300
              },
              {
                text: '500',
                value: 500
              },
              {
                text: 'Todos',
                value: -1
              }
            ]"
        >
          <template v-slot:items="props">
            <tr v-if="!isMobile">
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.NOTCONTADOR || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.NOTTITULO || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.NOTALCANCE ? "Privilégio": "Geral"}}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >
                <md-icon v-if="props.item.NOTURGENCIA" class="rs-priority-icon" style="color: #336699;">priority_high</md-icon>
              </td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.NOTVALIDADE && formatDate(props.item.NOTVALIDADE)}}              
                <md-icon v-if="props.item.NOTVALIDADE && isExpired(props.item.NOTVALIDADE)" class="rs-priority-icon" style="color: #336699;">timer_off</md-icon>
              </td>              
              <td              
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >
                <md-icon v-if="props.item.NOTCANCELADA" class="rs-priority-icon" style="color: #336699;">check_box</md-icon>
                <md-icon v-else class="rs-priority-icon" style="color: #336699;">check_box_outline_blank</md-icon>
              </td>
            </tr>
            <tr v-else>
              <td style="margin-bottom:25px">
                <ul class="flex-content">
                  <li class="flex-item" data-label="Contador:">{{ props.item.NOTCONTADOR }}</li>
                  <li class="flex-item" data-label="Titulo:">{{ props.item.NOTTITULO }}</li>
                  <li class="flex-item" data-label="Alcance:">{{ props.item.NOTALCANCE }}</li>
                  <li class="flex-item" data-label="Urgência:">{{ props.item.NOTURGENCIA }}</li>
                  <li class="flex-item" data-label="Validade:">{{ props.item.NOTVALIDADE && formatDate(props.item.NOTVALIDADE) }}</li>
                  <li class="flex-item" data-label="Cancelada:">{{ props.item.NOTCANCELADA }}</li>
                </ul>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              style="color: #000!important"
            >Nada foi encontrado.</v-alert>
          </template>

          <template v-slot:expand="props" v-if="!isMobile">
            <DataTableNotificacoes :NOTCONTADOR="props.item.NOTCONTADOR" />
          </template>

          <template
            slot="pageText"
            slot-scope="item"
          >Exibindo {{item.pageStart}} - {{item.pageStop}}, Total {{item.itemsLength}}</template>
        </v-data-table>
      </div>
    </v-layout>

    <md-snackbar :md-active.sync="empSaved">Sucesso!</md-snackbar>
    <md-snackbar :md-active.sync="errorSaved">Erro interno do servidor</md-snackbar>
    <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
  </div>
</template>
<script>
import * as Notificacoes from "../../providers/notificacoes.service";
//import DetalhesNotificacoes from "./detalhesNotificacoes";
import DataTableNotificacoes from "./DataTableNotificacoes";
import moment from "moment";

var jwt = require("jsonwebtoken");

export default {
  name: "tabela-boletos",
  components: {
    Map,
    DataTableNotificacoes
  },
  data() {
    return {
      isMobile: false,
      search: "",
      loadinData: true,
      loading5: false,
      msg: false,
      exibirExpirados: false,
      pagination: { rowsPerPage: 100 },
      errorSaved: false,
      empSaved: false,
      arquivosArr: [],
      headers: [
        {
          text: "Contador",
          value: "NOTCONTADOR"
        },
        {
          text: "Título",
          value: "NOTTITULO"
        },
        {
          text: "Alcance",
          value: "NOTALCANCE"
        },       
        {
          text: "Urgênte",
          value: "NOTURGENCIA"
        },       
        {
          text: "Validade",
          value: "NOTVALIDADE"
        },
        {
          text: "Cancelado",
          value: "NOTCANCELADA"
        }
      ],
      desserts: []
    };
  },

  methods: {    
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    findData() {
      var self = this;

      var fUser = jwt.decode(localStorage.getItem("token"));
  
      Notificacoes.getNotificacoes(!self.exibirExpirados).then(resp => {
        self.arquivosArr = resp;
        self.loadinData = false;
      });
    },   
    formatDate(_acRealRequisicao) {
      return moment(_acRealRequisicao).format("DD/MM/YYYY");
    },  
    isExpired(fDate) {
      return moment(new Date(fDate)).startOf('day') < moment(new Date()).startOf('day');
    }  
  },
  created() {
    var self = this;
    self.exibirExpirados = false;
    self.findData();
  }
};
</script>
<style scoped>
.copy {
  position: relative;
}
.copy .iconcopy {
  opacity: 0;
  position: absolute;
  color: rgb(97, 97, 97);
  top: 0;
}
.copy:hover .iconcopy {
  opacity: 1;
  cursor: pointer;
}
li {
  min-height: 58px;
}
.iconedit {
  font-size: 15px !important;
  position: absolute;
  top: 5px;
  right: 5px;
  opacity: 0;
  cursor: pointer;
}
.descarrude:hover .iconedit {
  opacity: 1;
}
.iconedit:hover {
  font-size: 16px !important;
  position: absolute;
  color: #000 !important;
  top: 5px;
}
</style>
<style>
#listAarquios .v-datatable__actions__select {
  opacity: 0;
  display: none !important;
}
</style>